import {styledFieldset} from 'components/Form/styles/FormView'

export const modalContent = {
    p: {margin: '15px 0'},
    ul: {
        margin: 0,
        paddingLeft: '20px',
    },
}

export const footerContent = {
    '> div:not(:first-child)': {
        display: 'flex',
        gap: '10px',
        justifyContent: 'flex-end',
        width: '100%',
    },
    'display': 'flex',
    'justifyContent': 'space-between',
    'width': '100%',
}

export const fieldset = {
    ...styledFieldset,
    marginBottom: 0,
}
